import React, { useState, useEffect } from 'react';

// Components
import Breadcrumbs from '../../../components/Breadcrumbs';

// Utils
import { getAlert,formatCurrency } from '../../../../utils/SamuiUtils';

function Main({ masterList, detailList, name, onPageInsert, onRowSelected }) {

  const [dataMasterList, setDataMasterList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(50);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredItems, setFilteredItems] = useState([]);

  useEffect(() => {
    initialize();
  }, [masterList, detailList]);

  useEffect(() => {
    filterItems();
  }, [searchTerm, dataMasterList]);

  const initialize = async () => {
    try {
      if (masterList && masterList.length > 0) {
        setDataMasterList(masterList);
      }
    } catch (error) {
      getAlert('FAILED', error.message);
    }
  };

  const filterItems = () => {
    if (searchTerm === '') {
      setFilteredItems(dataMasterList);
    } else {
      const lowercasedSearchTerm = searchTerm.toLowerCase();
      const filtered = dataMasterList.filter(item =>
        Object.values(item).some(value =>
          typeof value === 'string' &&
          value.toLowerCase().includes(lowercasedSearchTerm)
        )
      );
      setFilteredItems(filtered);
    }
  };

  const renderPageNumbers = () => {
    const totalPages = Math.ceil(dataMasterList.length / itemsPerPage);
    const pages = [];
    const maxVisiblePages = 5;
    const range = 2;

    if (totalPages > maxVisiblePages) {

      pages.push(
        <li
          key={1}
          className={`paginate_button page-item ${currentPage === 1 ? "active" : ""}`}
        >
          <a href="#" className="page-link" onClick={() => handlePageChange(1)}>
            1
          </a>
        </li>
      );

      if (currentPage - range > 2) {
        pages.push(
          <li key="ellipsis-start" className="paginate_button page-item">
            <a href="#" className="page-link">...</a>
          </li>
        );
      }

      for (let i = Math.max(currentPage - range, 2); i <= Math.min(currentPage + range, totalPages - 1); i++) {
        pages.push(
          <li
            key={i}
            className={`paginate_button page-item ${currentPage === i ? "active" : ""}`}
          >
            <a href="#" className="page-link" onClick={() => handlePageChange(i)}>
              {i}
            </a>
          </li>
        );
      }

      if (currentPage + range < totalPages - 1) {
        pages.push(
          <li key="ellipsis-end" className="paginate_button page-item">
            <a href="#" className="page-link">...</a>
          </li>
        );
      }

      pages.push(
        <li
          key={totalPages}
          className={`paginate_button page-item ${currentPage === totalPages ? "active" : ""}`}
        >
          <a href="#" className="page-link" onClick={() => handlePageChange(totalPages)}>
            {totalPages}
          </a>
        </li>
      );
    } else {

      for (let i = 1; i <= totalPages; i++) {
        pages.push(
          <li
            key={i}
            className={`paginate_button page-item ${currentPage === i ? "active" : ""}`}
          >
            <a href="#" className="page-link" onClick={() => handlePageChange(i)}>
              {i}
            </a>
          </li>
        );
      }
    }

    return pages;
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleItemsPerPageChange = (event) => {
    setItemsPerPage(Number(event.target.value));
    setCurrentPage(1); 
  };


  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredItems.slice(indexOfFirstItem, indexOfLastItem);
  return (
    <>
      <div className="page-header d-flex justify-content-between align-items-center mb-0">
        <Breadcrumbs page={name} items={[
          { name: 'ข้อมูลตั้งต้น', url: '/initialdata' },
          { name: name, url: '/tbsetitem' },
        ]} />
      </div>
      <div className='p-3 rounded-3 my-2 shadow-lg' style={{ backgroundColor: '#ffff' }}>
        <div className='row'>
          <div className="col-3 d-flex">
            <div className="navbar-form nav-search">
              <div className="input-group">
                <input
                  type="text"
                  placeholder="ค้นหาเอกสาร..."
                  className="form-control"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
                <span className="input-group-text">
                  <i className="fas fa-search"></i>
                </span>
              </div>
            </div>
          </div>
          <div className="col-9 d-flex justify-content-end">
            <button
              onClick={onPageInsert}
              className="btn btn-warning text-white ms-2"
              type="button"
            >
              สร้าง{name} <i className="fa fa-plus"></i>
            </button>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <div className="card p-2">
            <div className="table-responsive" style={{ maxHeight: '80vh', overflowY: 'auto' }}>
              <table id="basic-datatables" className="table table-striped table-hover">
                <thead className="thead-dark">
                  <tr>
                    <th className="text-center" style={{ width: "2%" }}>
                      #
                    </th>
                    {/* <th className="text-center" style={{ width: "9%" }} >
                      Barcode
                    </th> */}
                    <th className="text-center" style={{ width: "8%" }}>
                      รหัสสินค้า
                    </th>
                    <th className="text-center" style={{ width: "20%" }}>
                      ชื่อสินค้า
                    </th>
                    <th className="text-center" style={{width: "10%"}}>
                      ชื่อสินค้าแบบย่อ
                    </th>
                      <th className="text-center" style={{ width: "4%" }}>
                      หน่วยซื้อ
                    </th>
                       <th className="text-center" style={{ width: "4%" }}>
                      หน่วยสต๊อค
                    </th>
                       <th className="text-center" style={{ width: "4%" }}>
                      หน่วยขาย
                    </th>
                    <th className="text-center" style={{ width: "5%" }}>
                      คงเหลือ 
                      <br />
                      (คลังสินค้า)
                    </th>
                    <th className="text-center" style={{ width: "7%" }}>
                      จน.หน่วยซื้อ
                    </th>
                    <th className="text-center" style={{ width: "7%" }}>
                      จน.หน่วยสต๊อค
                    </th>
                    <th className="text-center" style={{ width: "7%" }}>
                      จน.หน่วยขาย
                    </th>
                    <th className="text-center" style={{ width: "7%" }}>
                      ต้นทุนสินค้า
                    </th>
                    <th className="text-center" style={{ width: "7%" }}>
                      ราคาสินค้า
                    </th>
                    <th className="text-center" style={{ width: "7%" }}>
                      ราคาสินค้าA
                    </th>
                    <th className="text-center" style={{ width: "7%" }}>
                      ราคาสินค้าB
                    </th>
                    <th className="text-center" style={{ width: "3%" }}>
                      แก้ไข
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {currentItems.length > 0 ? (
                    currentItems.map((item, index) => (
                      <tr
                        key={index}
                        style={{ cursor: "pointer" }}
                      >
                        <td className="text-center">{indexOfFirstItem + index + 1}</td>
                        <td className="text-center">
                          {item.Item_Code}
                        </td>
                        <td className="text-left">
                          {item.Item_Name}
                        </td>
                        <td className="text-center">
                          {item.Item_Short_Name}
                        </td>
                         <td className="text-center">
                          {item.Item_Unit_IN}
                        </td>
                         <td className="text-center">
                          {item.Item_Unit_ST}
                        </td>
                         <td className="text-center">
                          {item.Item_Unit_OUT}
                        </td>
                           <td className="text-end">
                           {item.stock}
                        </td>
                        <td className="text-end">
                          {formatCurrency(item?.Item_Unit_IN)}
                        </td>
                        <td className="text-end">
                          {formatCurrency(item?.Item_Unit_ST)}
                        </td>
                        <td className="text-end">
                          {formatCurrency(item?.Item_Unit_OUT)}
                        </td>
                     
                        <td className="text-end">
                          {formatCurrency(item?.Item_Cost)}
                        </td>
                        <td className="text-end">
                          {formatCurrency(item?.Item_Price)}
                        </td>
                        <td className="text-end">
                          {formatCurrency(item?.Item_PriceA)}
                        </td>
                        <td className="text-end">
                          {formatCurrency(item?.Item_PriceB)}
                        </td>
                        <td className="text-center">
                          <i onClick={() => onRowSelected(item)} className="fas fa-edit fw-bold" style={{ color: "#EF6C00" }} />
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="14">
                        <center>
                          <h5>ไม่พบข้อมูล</h5>
                        </center>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            <div className="row mt-3">
              <div className="col-12 d-flex justify-content-between">
                {/* Dropdown for Items Per Page */}
                <div className="d-flex align-items-center">
                  <label htmlFor="itemsPerPage" className="mr-2">Items per page:</label>
                  <select
                    id="itemsPerPage"
                    value={itemsPerPage}
                    onChange={handleItemsPerPageChange}
                    className="form-select"
                  >
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                    <option value={150}>150</option>
                    <option value={dataMasterList.length}>All</option>
                  </select>
                </div>

                <div className="dataTables_paginate paging_simple_numbers">
                  <ul className="pagination">
                    <li className={`paginate_button page-item previous ${currentPage === 1 ? "disabled" : ""}`}>
                      <a
                        href="#"
                        className="page-link"
                        onClick={() => handlePageChange(currentPage - 1)}
                      >
                        Previous
                      </a>
                    </li>
                    {renderPageNumbers()}
                    <li
                      className={`paginate_button page-item next ${currentPage ===
                        Math.ceil(dataMasterList.length / itemsPerPage)
                        ? "disabled"
                        : ""
                        }`}
                    >
                      <a
                        href="#"
                        className="page-link"
                        onClick={() => handlePageChange(currentPage + 1)}
                      >
                        Next
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div >
    </>
  );
}

export default Main;